import yup from '../../../config/yup';

export const jdbcWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('jdbcWriter'),
  onError: yup.string(),
  delayedRead: yup.boolean(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    databaseName: yup.string().required('Database Name is required'),
    tableName: yup.string().required('Table Name is required'),
    driver: yup.string().required('Driver is required'),
    host: yup.string(),
    port: yup.number().typeError('Port must be a number'),
    username: yup.string().required('Username is required'),
    password: yup.string().required('Password is required'),
  }),
});
